import { useEffect, useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, MapPinCheck } from "lucide-react";

export const AddressCheckButton = ({ onDone }) => {
  const [job, setJob] = useState(null);
  const timer = useRef(null);
  const poll = async () => {
    const { data } = await api.get("/address-check/status");
    setJob(data);
    if (data.status === "running") { timer.current = setTimeout(poll, 3000); return; }
    if (data.status === "done") {
      toast.success(`Addresses checked: ${data.checked} · verified ${data.verified} · auto-corrected ${data.corrected} · need fixing ${data.needs_fixing}`);
      onDone?.();
    }
    if (data.status === "error") toast.error(data.error || "Address check failed");
  };
  useEffect(() => () => clearTimeout(timer.current), []);
  const start = async () => {
    try { await api.post("/address-check"); setJob({ status: "running" }); timer.current = setTimeout(poll, 2000); }
    catch (e) { toast.error(apiError(e)); }
  };
  const running = job?.status === "running";
  return (
    <Button variant="outline" onClick={start} disabled={running} data-testid="verify-addresses-btn"
      title="Checks every lead's owner mailing address with USPS and auto-corrects it before postcards are sent">
      {running ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <MapPinCheck className="mr-2 h-4 w-4" />}
      {running ? "Checking addresses…" : "Verify all addresses"}
    </Button>
  );
};
